import { render, staticRenderFns } from "./FileConfigRoleList.vue?vue&type=template&id=38dc73c1&scoped=true&"
import script from "./FileConfigRoleList.vue?vue&type=script&lang=js&"
export * from "./FileConfigRoleList.vue?vue&type=script&lang=js&"
import style0 from "./FileConfigRoleList.vue?vue&type=style&index=0&id=38dc73c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dc73c1",
  null
  
)

export default component.exports